export const AddressValidations = {
  zipcode: /^(?!-)(?!.*--)(?!.*-$)[A-Za-z0-9]*(?:-[A-Za-z0-9]*)?$/,
};
